import { useContext, useEffect, useState } from "react";
import { getHouseMainInformation } from "./house-service";
import { HouseMainInformation } from "./types";
import { HouseCompetitionData } from "./contextProvider";
import DOMPurify from "dompurify";

const HouseMainInfo = ({ classNames }: { classNames?: string }) => {
  const [houseMainData, setHouseMainData] = useState<string>("");
  const { prizeId } = useContext(HouseCompetitionData);
  useEffect(() => {
    if (prizeId) {
      getInformation();
    }
  }, [prizeId]);

  const getInformation = async () => {
    const response = await getHouseMainInformation(prizeId);
    const { HouseMainInformation } = (await response.json()) as HouseMainInformation;
    setHouseMainData(HouseMainInformation);
  };

  return <div className={classNames} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(houseMainData) }} />;
};

{
  /* <div className="border border-solid w-[1px] h-full"></div>; */
}

export default HouseMainInfo;
